import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { useForm } from 'react-hook-form';
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { Fetch } from "../../shared/Fetch";
import { IClientCompanyDropdown, IStatusDropdown } from "../../models/IDropdown";
import { useEffect, useState } from "react";
import { JVDropdown } from "../../shared/JVDropdown";

export interface IFilterBlackListMast {
    company?: IClientCompanyDropdown,
    blacklist_Status_ID?: number | null,
    vendor_Company_ID?: number,
    blacklist_Status?: string


}
export const EmptyFilter: IFilterBlackListMast = {
    company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    vendor_Company_ID: undefined,
    blacklist_Status_ID: null
}
interface Iprops {
    filters: IFilterBlackListMast,
    setFilters: (filters: IFilterBlackListMast) => void,
}

export const Filter = (props: Iprops) => {
    const [clientCompanies, setClientCompanies] = useState<Array<IClientCompanyDropdown>>();
    const [status, setStatus] = useState<Array<IStatusDropdown>>();
    const toast = useRef<any>(null);

    const { control, handleSubmit, reset, watch } = useForm<IFilterBlackListMast>({
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const loadClientCompanies = async (filter: string | null) => {
        const response = await Fetch("Dropdown/blacklist_vendor_companies", "GET", null, `filter=${filter}`, null);
        if (response) {
            const data: Array<IClientCompanyDropdown> = await response.json();
            setClientCompanies(data);
        }
    }

    const loadStatus = async () => {
        const response = await Fetch("Dropdown/blacklistStatus", "GET", null, null, null);
        if (response) {
            const data: Array<IStatusDropdown> = await response.json();
            setStatus(data);
        }
    }

    const completeMethodClientCompanies = (event: { query: string }) => {
        loadClientCompanies(event.query);
    }
    const searchToDB = async (body: IFilterBlackListMast) => {
        props.setFilters(body);
    }

    function onSubmit(data: IFilterBlackListMast) {
        data.vendor_Company_ID = data.company?.vendor_Company_ID;
        searchToDB(data);
    }

    useEffect(() => {
        loadStatus()
    }, []);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdownInput column={3} completeMethod={completeMethodClientCompanies} label="Company Name" control={control} name="company" options={clientCompanies} optionLabel="vendor_Company_Name" placeholder="Search Client/Company" />
                <JVDropdown column={3} label="BlackList Status" control={control} name="blacklist_Status_ID" options={status} optionLabel="blacklist_Status" optionValue="blacklist_Status_ID" placeholder="Select Status" />
                <div style={{ margin: '10px 0', width: '100%' }}></div>
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SEARCH" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset(EmptyFilter) }} type="button"></Button>
                </div>
            </form>
            <Toast ref={toast} />
        </>
    );
}